import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const hasRecaptcha = () => Boolean(SITE_KEY);

export const getRecaptchaToken = (widgetId) => {
  if (!SITE_KEY || !window.grecaptcha) return null;
  return window.grecaptcha.getResponse(widgetId) || null;
};

export const resetRecaptcha = (widgetId) => {
  if (SITE_KEY && window.grecaptcha && widgetId != null) window.grecaptcha.reset(widgetId);
};

export const Recaptcha = ({ onReady }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!SITE_KEY) return;
    const render = () => {
      if (ref.current && !ref.current.hasChildNodes()) {
        const id = window.grecaptcha.render(ref.current, { sitekey: SITE_KEY, theme: "dark" });
        onReady?.(id);
      }
    };
    if (window.grecaptcha?.render) return render();
    const cb = "__recaptchaReady";
    window[cb] = render;
    if (!document.getElementById("recaptcha-script")) {
      const s = document.createElement("script");
      s.id = "recaptcha-script";
      s.src = `https://www.google.com/recaptcha/api.js?onload=${cb}&render=explicit`;
      s.async = true;
      document.head.appendChild(s);
    }
  }, [onReady]);
  if (!SITE_KEY) return null;
  return <div ref={ref} className="mt-5" data-testid="recaptcha-widget" />;
};

export const Honeypot = ({ value, onChange }) => (
  <input
    type="text"
    name="website"
    value={value}
    onChange={onChange}
    tabIndex={-1}
    autoComplete="off"
    aria-hidden="true"
    className="absolute opacity-0 h-0 w-0 pointer-events-none"
    data-testid="honeypot-field"
  />
);
